var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-dialog", {
    attrs: {
      title: _vm.title,
      fullscreen: "",
      visible: _vm.visible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      },
      close: _vm.close
    }
  }, [_c("div", {
    staticClass: "map-view",
    attrs: {
      id: "map-view"
    }
  }), _c("div", {
    staticClass: "point-view"
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      placeholder: "请输入内容",
      "show-word-limit": "",
      rows: "5"
    },
    model: {
      value: _vm.jsonAoi,
      callback: function callback($$v) {
        _vm.jsonAoi = $$v;
      },
      expression: "jsonAoi"
    }
  })], 1), _c("div", {
    staticClass: "set-right"
  }, [_c("el-button", {
    attrs: {
      size: "small",
      type: "primary"
    },
    on: {
      click: _vm.setBusinessAOI
    }
  }, [_vm._v("更新视图 ")])], 1), _c("div", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      size: "small"
    },
    on: {
      click: function click($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v("取 消 ")]), _c("el-button", {
    attrs: {
      size: "small",
      type: "primary"
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v("确 定 ")])], 1)])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };